import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '@app-services/user/user.service';

@Component({
  selector: 'app-leave-session-dialog',
  templateUrl: './leave-session-dialog.component.html',
  styleUrls: ['./leave-session-dialog.component.css']
})
export class LeaveSessionDialogComponent implements OnInit {

  public userTypeId: number = 1;

  constructor(
    private _userService: UserService,
    private dialogRef: MatDialogRef<LeaveSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.userTypeId = this._userService.getUserType()
  }

  dismissLeaveSession = () => {
    this.dialogRef.close({event: 'continueLearning'});
  }

  continueLeaveSession = () => {
    this.dialogRef.close({event: 'stopLearning'});
  }

}
